module.exports = "pegasus/assets/glyphicons-halflings.png";